import Badge from "@/components/Badge";

const BadgesCell = ({ items, renderBadgeContent }) => {
    if (!items || items.length === 0) return "-";
  
    return (
      <div className="flex flex-wrap max-w-full overflow-hidden gap-1 p-1">
        {items.map((item, index) => (
          <Badge key={item.id || index}>
            {renderBadgeContent ? renderBadgeContent(item) : item.code ? `${item.code} - ${item.name}` : item.name}
          </Badge>
        ))}
      </div>
    );
  };
  
  export default BadgesCell;
  